module.exports = __webpack_public_path__ + "img/videoBac.a5b8553b.png";